module.exports = __webpack_public_path__ + "assets/img/ofa-qrdode.8ebd63f4.png";